"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZINDEX = exports.TRUTHY = exports.ShowAllProductId = exports.SHOWALL_TAB = exports.OTHER_TAB = exports.OPEN = exports.MODAL = exports.MIN_MOBILE_WIDTH = exports.MAX_TILES_TABLET = exports.MAX_TILES = exports.INDEX_TO_SPLIT = exports.GRID_ROW_GAP = exports.DEVICE_TYPE = exports.DATA_SHOW_ALL = exports.DATA_OTHER_TAB = exports.DATA_MODAL = exports.DATA_CLOSE = exports.CLOSE_ICON = exports.AVG_TILE_WIDTH = void 0;
var AVG_TILE_WIDTH = 120;
exports.AVG_TILE_WIDTH = AVG_TILE_WIDTH;
var MIN_MOBILE_WIDTH = 700;
exports.MIN_MOBILE_WIDTH = MIN_MOBILE_WIDTH;
var MAX_TILES = 8;
exports.MAX_TILES = MAX_TILES;
var MAX_TILES_TABLET = 4;
exports.MAX_TILES_TABLET = MAX_TILES_TABLET;
var GRID_ROW_GAP = '20px';
exports.GRID_ROW_GAP = GRID_ROW_GAP;
var DEVICE_TYPE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var ZINDEX = 10;
exports.ZINDEX = ZINDEX;
var OPEN = true;
exports.OPEN = OPEN;
var DATA_SHOW_ALL = 'data-show';
exports.DATA_SHOW_ALL = DATA_SHOW_ALL;
var SHOWALL_TAB = 'showAllTab';
exports.SHOWALL_TAB = SHOWALL_TAB;
var DATA_OTHER_TAB = 'data-tile';
exports.DATA_OTHER_TAB = DATA_OTHER_TAB;
var OTHER_TAB = 'other-tile';
exports.OTHER_TAB = OTHER_TAB;
var DATA_MODAL = 'data-modal';
exports.DATA_MODAL = DATA_MODAL;
var MODAL = 'modal';
exports.MODAL = MODAL;
var DATA_CLOSE = 'data-icon';
exports.DATA_CLOSE = DATA_CLOSE;
var CLOSE_ICON = 'close-icon';
exports.CLOSE_ICON = CLOSE_ICON;
var INDEX_TO_SPLIT = 7;
exports.INDEX_TO_SPLIT = INDEX_TO_SPLIT;
var ShowAllProductId = 'showPrdID';
exports.ShowAllProductId = ShowAllProductId;
var TRUTHY = 'TRUE';
exports.TRUTHY = TRUTHY;